import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SlideContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  padding-top: 4.5rem;
  max-width: 1200px;
  margin: 0 auto;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 0.8rem;
    padding-top: 4rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
    padding-top: 3.5rem;
  }
`;

const SlideTitle = styled(motion.h2)`
  font-size: 3.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(45deg, #6F1A3F, #C82B3F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 1024px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const ContactInfo = styled.div`
  color: #ccc;
  text-align: center;
`;

const ContactTitle = styled.h3`
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 2rem;
  text-align: center;
`;

const ContactDescription = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 2rem;
  color: #ccc;
  text-align: center;
`;

const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ContactItem = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  border: 1px solid rgba(111, 26, 63, 0.2);
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(200, 43, 63, 0.5);
    transform: translateX(10px);
    background: rgba(111, 26, 63, 0.1);
  }
`;

const ContactIcon = styled.div`
  font-size: 1.5rem;
  color: #C82B3F;
`;

const ContactText = styled.div`
  color: #fff;
  font-weight: 500;
  font-size: 1.1rem;
`;


const Slide11 = () => {

  const contactInfo = [
    {
      icon: '📧',
      text: 'mqudah@3amdigitallabs.com'
    },
    {
      icon: '📞',
      text: '+962 (079) 543-0116'
    },
    {
      icon: '🌐',
      text: '3amdigitallabs.com'
    },
    {
      icon: '📍',
      text: '23B, Ground Floor, King Hussein Business Park, Amman, 11185, Jordan'
    }
  ];

  return (
    <SlideContainer>
      <SlideTitle
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Contact Information
      </SlideTitle>

      <ContentContainer>
        <ContactInfo>
          <ContactTitle
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Let's Build Something Amazing Together
          </ContactTitle>
          
          <ContactDescription
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Ready to transform your business with cutting-edge technology and strategic marketing? 
            Contact us today to discuss your project and discover how we can help you achieve your goals.
          </ContactDescription>

          <ContactDetails>
            {contactInfo.map((item, index) => (
              <ContactItem
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 + index * 0.1 }}
                whileHover={{ scale: 1.02 }}
              >
                <ContactIcon>{item.icon}</ContactIcon>
                <ContactText>{item.text}</ContactText>
              </ContactItem>
            ))}
          </ContactDetails>
        </ContactInfo>
      </ContentContainer>
    </SlideContainer>
  );
};

export default Slide11;
